<template>
    <div class="new-category"> 
        <category
            v-if="!editing" 
            label="Create new category"
            :selected="true"
            :disabled="true"
            @click="editing=!editing">
        </category>
        <div v-else class="new-category-wrapper">
            <input v-model="category" class="new-category-input" @blur="addNewCategory">
            <div class="add-category">+</div>
        </div>
    </div>
</template>

<script>
import Category from './Category'

export default {
    components: {
        Category
    },
    props: {
        categories: {
            type: Array
        },
        label: {
            type: String
        }
    },
    computed: {
        unselectedCategories: function() {
            return this.categories && this.categories.filter(category => !category.selected)
        }
    },
    data() {
        return {
            category: '',
            editing: false
        }
    },
    methods: {
        addNewCategory: function() {
            this.editing = false;
            this.$emit('addNewCategory', this.category);
            this.category="";
        }
    }
}
</script>

<style scoped lang="scss">
@use '../../styles/theme.scss';

.new-category {
    display: inline-block;
    margin-right: 10px;
}
.new-category-wrapper {
    display: flex;
}
input.new-category-input { 
    outline: none;
    background: #ffffff;
    border: 1px solid #5A4BB0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border-radius: 4px;
    padding: 6px 8px;
    margin-bottom: 8px;
}
.add-category{ 
    background-color: theme.$secondary-color;
    width: 34px;
    height: 34px;
    text-align: center;
    font-size: 24px;
    margin-left: 8px;
    border-radius: theme.$button-border-radius; 
    display: inline-block;
    color: theme.$primary-color;
    cursor: pointer;
}
.new-category .category.selected {
    margin-right: 0;
}
</style>